import { useMutation } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import Urls from "../urls"

export default function useChangeProfile() {
    return useMutation({ mutationFn: (profile: unknown) => axiosClient.put(Urls.profileChange(), profile) })
}
